export default __webpack_public_path__ + "static/step_2_ru-ec8c12b914eccf77f85d5156ec27fb85.svg";